import React from 'react';
import ReactMediaPlayer from '../../../../../../../../../components/ReactMediaPlayer/ReactMediaPlayer';
import EditableCaption from '../../../../../../components/EditableCaption';

const onCaptionChange = (itemId, dispatch) => (text) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    caption: text
  });
};

const editorOptions = {
  /*   paste: {
      forcePlainText: false,
      cleanPastedHTML: false
    }, */
  disableReturn: true,
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' }
    ]
  }
};

const renderCaption = (item, editable, dispatch) => {
  const caption = item.caption;
  if (!caption) {
    return null;
  }

  return (
    <EditableCaption
      wrapperClassName="block-audio__caption brand--body brand--linkColor"
      text={caption}
      placeholder="Add a caption"
      component="figcaption"
      editable={editable}
      onChange={onCaptionChange(item._id, dispatch)}
      editorOptions={editorOptions}
    />
  );
};

export default (props) => {
  const lesson = props.lesson;
  const item = lesson.items[0];

  const settings = lesson.settings;

  return (
    <div className="block-audio">
      <div className="block-audio__wrapper">
        <div className="block-audio__item">
          <div className="audio-player">
            <div className="audio-player__housing">
              <ReactMediaPlayer src={item.media.audio.src} style={{ width: '100%' }} />
            </div>
          </div>
          {renderCaption(item, props.editable, props.dispatch)}
        </div>
      </div>
    </div>
  );
};
